import { render, staticRenderFns } from "./performanceDetail.vue?vue&type=template&id=475b28c5&scoped=true"
import script from "./performanceDetail.vue?vue&type=script&lang=js"
export * from "./performanceDetail.vue?vue&type=script&lang=js"
import style0 from "./performanceDetail.vue?vue&type=style&index=0&id=475b28c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b28c5",
  null
  
)

export default component.exports